"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOptions = createOptions;

function createOptions() {
  var proxy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.defineProperty(proxy, 'passive', {
    get: function get() {
      this.isPassiveSupported = true;
      return true;
    },
    enumerable: true
  });
  return proxy;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vanilla-swipe/lib/utils/createOptions.js
// module id = 387
// module chunks = 0